module.exports = __webpack_public_path__ + "img/icon-2.205595c7.png";